/* eslint-disable prettier/prettier */
import { createStore } from "vuex";
import ViewConfiguration, { Page } from "@/models/Page";
import { IPage } from "@/interfaces/IPage";

import { IViewConfiguration } from "@/interfaces/IViewConfiguration";
import { TYPES } from "@/types";
import { myContainer } from "@/inversify.config";
import * as dtos from "@/models/dtos";
import { IEmploymentService } from "@/interfaces/IEmploymentService";
// const router = useRouter();
const client = myContainer.get<IEmploymentService>(TYPES.IEmploymentService);
import router from "@/router";

// Import Modules
import userStore from "./modules/userStore";
import containerStore from "./modules/containerStore";
import positionStore from "./modules/positionStore";
import applicantStore from "./modules/applicantStore";
import formbuilderStore from "./modules/formbuilderStore";
import profileStore from "./modules/profileStore";
import skillStore from "./modules/skillStore";
import notificationStore from "./modules/notificationStore";
import newsStore from "@/features/news/store/newsStore";
import billingStore from "./modules/billingStore";
import externalStore from "./modules/externalStore";
import {
  ApplicantForm,
  FormItemBuilder,
  FormItemModel,
} from "@/models/CheckboxGroup";
import { ApplicantUser } from "@/models/ApplicantUser";
import { FormBuilder2 } from "@/models/FormBuilder2";
import { ToastNotification } from "@/models/ToastNotification";

const store = createStore({
  state: {
    counter: 0,
    colorCode: "blue",
    pages: [] as Array<IPage>,
    containers: [] as Array<dtos.ContainerResponse>,
    container: {} as dtos.ContainerResponse,
    positionApplicants: [] as Array<dtos.ApplicantPositionResponse>,
    positions: [] as Array<dtos.PositionResponse>,
    latestUserPermissions: {} as dtos.CreateContainerUserPermissionResponse,
    login: {
      username: "stefan@gong.se",
      password: "Abc 123!",
    },
    formBuilderList: [{ id: 0, type: "form_checkbox", label: "Checkbox" }],
    formBuilderEditor: { open: false, editing: 0 },
    labelTemplates: [] as Array<dtos.LabelTemplate>,
    formBuilderItems: [] as Array<FormItemModel>,
  },
  getters: {
    getLabelInteresDefault(state) {
      return state.container?.labels?.filter(
        (px) => px.labelType.name.toLowerCase() === "interest" && px.isDefault
      );
    },

    getformBuilderItems(state) {
      return state.formBuilderItems?.filter(
        (px) => px.item.type !== "checkbox"
      );
    },

    getformBuilderAllItems(state) {
      return state.formBuilderItems?.map((px) => px.item);
    },
    getLatestUserPermissions(state) {
      return state.latestUserPermissions;
    },
    form: (state, getters, rootState, rootGetters) => {
      return rootGetters['formbuilder/form'];
    },
  },
  mutations: {
    formBuilderItemsAdd(state, item: FormItemModel) {
      state.formBuilderItems.push(item);
    },
    formBuilderItemsRemove(state, index) {
      state.formBuilderItems.splice(index, 1);
    },
    formBuilderItemsChange(state, moved) {
      state.formBuilderItems.splice(moved.oldIndex, 1);
      state.formBuilderItems.splice(moved.newIndex, 0, moved.element);
    },

    setPositionApplicants(state, value) {
      state.positionApplicants = value;
    },

    setLatestUserPermissions(state, value) {
      state.latestUserPermissions = value;
    },

    setFormBuilderEdit(state, value) {
      state.formBuilderItems = Array<any>();
    },
    resetFormBuilder(state, value) {
      state.formBuilderItems = Array<any>();
    },
  },
  actions: {
    async updateContainerUserPermissions(
      { commit, getters },
      item: dtos.UpdateContainerUserPermission
    ) {
      await client.Container.updateContainerUserPermission(item);
      this.dispatch("reloadContainer");
    },
    async addContainerUserPermission(
      { dispatch, commit, getters },
      item: dtos.CreateContainerUserPermission[]
    ) {
      item.forEach(async (element) => {
        const permission = await client.Container.createUserContainerPermission(
          element
        );
        this.commit("setLatestUserPermissions", permission);
        await dispatch("reloadContainer");
      });
    },
    async deleteContainerUserPermission(
      { commit },
      item: dtos.DeleteContainerUserPermission[]
    ) {
      await item.forEach(async (element) => {
        await client.Container.deleteUserContainerPermission(element);
      });
      this.dispatch("reloadContainer");
    },
    async updateAccount({ commit, dispatch }, item) {
      await client.Container.updateAccount(item);
      this.dispatch("reloadContainer");
    },

    async updateLabel({ commit }, item) {
      await client.Container.updateLabel(item);
      this.dispatch("reloadContainer");
    },
    async updateApplicant({ commit, dispatch }, item) {
      await client.JobPosition.updateApplicant(item);
      dispatch("addNotification", new ToastNotification("success", "Sparad"));
    },
    async createApplicant({ commit }, item) {
      await client.JobPosition.createApplicant(
        item.email,
        item.positionId,
        item.metadata
      );
    },
    async createPublicApplicant({ commit, dispatch }, item) {
      await client
        .createApplicant(item.email, item.positionId, item.metadata)
        .then((response) => {
          dispatch("createApplicantNotification", {
            applicantId: response.data.id,
            positionId: item.positionId,
            positionName: item.positionName,
            applicantName: item.applicantName,
          });
        });
    },
    setFormBuilderEdit({ commit }, item) {
      commit("setFormBuilderEdit", item);
      const model = new FormItemBuilder(item.metadata);

      model.Items.forEach((px) => {
        this.dispatch("formBuilderItemsAdd", px);
      });
      router.push("/admin/formbuilder");
    },

    setFormBuilderApplicantEdit({ commit }, item: ApplicantUser) {
      commit("setFormBuilderEdit", item.Position);
      const model = new FormItemBuilder(item.User.metadata);

      model.Items.forEach((px) => {
        this.dispatch("formBuilderItemsAdd", px);
      });
      router.push("/admin/formbuilderedit");
    },
    resetFormBuilder({ commit }) {
      commit("resetFormBuilder", new dtos.PositionResponse());
    },
    async editPosition({ commit }, item) {
      item.containerId = this.state.container.id;

      await client.Container.createPosition(item).then((response) => {
        router.push("/admin/positions");
      });
    },
    async deletePosition({ commit }, { id, labelId }) {
      try {
        await client.JobPosition.deletePosition(id);
        this.dispatch("loadPositionApplicants", {
          positionId: id,
          labelId: labelId,
        });
        router.push("/admin/positions");
      } catch (error) {
        //
      }
    },
    async exportPositionApplicants({ commit }, item) {
      client.JobPosition.exportApplicants(item).then((px) => {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(new Blob([px.data]));
        link.setAttribute("download", "report.csv");
        document.body.appendChild(link);
        link.click();
      });
    },

    formBuilderItemsAdd({ commit }, item) {
      this.commit("formBuilderItemsAdd", item);
    },
    formBuilderItemsRemove({ commit }, index) {
      this.commit("formBuilderItemsRemove", index);
    },
    formBuilderItemsChange({ commit }, moved) {
      this.commit("formBuilderItemsChange", moved);
    },

    async changePassword({ commit }, email) {
      await client.Container.resetPassword(email);
    },

    async createPositionApplicant({ commit, dispatch }, id) {
      const item = await client.JobPosition.getById(id);

      const builder = new FormBuilder2(item.metadata, false);
      const appPosition = new dtos.ApplicantPositionResponse();
      appPosition.info = new dtos.ApplicantInfo();
      appPosition.info.firstname = "";
      appPosition.info.lastname = "";
      appPosition.userId = "";
      appPosition.position = item;
      appPosition.positionId = item.id;
      appPosition.metadata = item.metadata;
      const applicant = new ApplicantForm(builder.Items, appPosition);

      commit("loadPositionApplicant", applicant);
      dispatch("addNotification", new ToastNotification("success", "Sparad"));
    },
    async loadPages({ commit }) {
      const viewConfiguration = new ViewConfiguration("1");
      const viewConfiguration2 = new ViewConfiguration("2");

      const viewConfigurations = new Array<IViewConfiguration>();
      viewConfigurations.push(viewConfiguration);
      viewConfigurations.push(viewConfiguration2);
      const page = new Page(1, viewConfigurations, "myColorCode");
      const array = new Array<IPage>();
      array.push(page);
      commit("loadPages", array);
    },

    setUsername({ commit }, value) {
      commit("setUsername", value);
    },
    setPassword({ commit }, value) {
      commit("setPassword", value);
    },
  },
  modules: {
    userStore,
    containerStore,
    positionStore,
    applicantStore,
    formbuilder: formbuilderStore,
    notificationStore,
    profileStore,
    skillStore,
    newsStore,
    billing: billingStore,
    externalStore,
  },
});

// Update the store binding in the DI container after store creation
myContainer.rebind<typeof store>("Store").toConstantValue(store);

export default store;
